import { createClient } from '@supabase/supabase-js';
import { storageDinamico } from './pinStorage';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

// SSO del hub: la sesión se guarda en cookie domain=.vlscr.net (ver cookieStorage),
// compartida con vlscr.net y los demás subdominios (comisiones, visitas, rw…).
// storageDinamico delega en cookieStorage salvo en modo PIN (localStorage aislado).
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: storageDinamico,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
